import { auth } from "@/firebase";

/** Refreshes ID token and returns whether the current user has admin: true. */
export async function refreshAdminClaim() {
  const user = auth.currentUser;
  if (!user) {
    return { user: null, isAdmin: false };
  }
  const token = await user.getIdTokenResult(true);
  const isAdmin = token.claims.admin === true;
  return { user, isAdmin };
}
